import { Injectable } from '@angular/core';
import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { TenantSelectionService } from 'src/app/Services/tenant-selection.service';
import { environment } from 'src/environments/environment';
import { BuildAuthService } from 'src/app/Services/build-auth.service';
import { AbstractRepository } from '../repository/abstract-repository';


@Injectable({
    providedIn: 'root'
})
export class BerechtigungRepository extends AbstractRepository<Permission> {

    constructor(private http: HttpClient, private tenantService: TenantSelectionService, private authBuilder: BuildAuthService) {
        super();
    }

    getUrl(): string {
        return `${environment.backendURL}/${this.authBuilder.buildAuth()}/berechtigung`;
    }

    post(berechtigung: Permission) {
        return this.http.post(this.getUrl(), berechtigung);
    }

    getAll(): Promise<Permission[]> {
        return new Promise((resolve, reject) => {
            this.http.get(`${this.getUrl()}`).subscribe((res: Permission[]) => resolve(res));
        });
    }

    getWithID(id: number): Promise<Permission> {
        throw new Error('Method not implemented.');
    }

    delete(id: number): Observable<any> {
        const options = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
            }),
            body: {
                'ID': id
            }
        };
        return this.http.delete(this.getUrl(), options);
    }

    update(berechtigung: Permission) {
        return this.http.post(`${this.getUrl()}/update`, berechtigung);
    }

    getUrlForImport(): string {
        return `${environment.backendURL}/${this.authBuilder.buildAuth()}/berechtigungImport`;
    }

    getCsvHeaders(): string[] {
        return [
            // Spalten für die generierte .csv Datei
            'Name',
            'Beschreibung',
            'Funktionen'
        ];
    }

    /**
     * This method imports the given data into the database.
     * @param importObjects - Array of objects to be inserted.
     */
    import(importObjects: Permission[]) {
        return this.http.post(this.getUrlForImport(), importObjects);
    }

    getRepoName(): string {
        return 'Berechtigung-';
    }

    buildObject(
        Name: string,
        Beschreibung: string,
        Funktionen: string,
        ID?: number,
    ): Permission {
        return {
            Name: Name,
            Description: Beschreibung,
            Functions: Funktionen,
            ID: ID,
            tenant: this.tenantService.getCurrentTenantID(),
        };
    }

    buildImportObjects(importObjectStringArray): Permission[] {

        const objectsFromCsv: Permission[] = [];

        for (let i = 1; i < importObjectStringArray.length; i++) {
            const Name = importObjectStringArray[i][0];
            const Kontonummer = importObjectStringArray[i][1];
            const Funktionen = importObjectStringArray[i][2];

            objectsFromCsv.push(this.buildObject(
                Name,
                Kontonummer,
                Funktionen
            ));
        }
        return objectsFromCsv;
    }
}
